module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_a01/main_pc_f34896255ee0f06ca0b83e1e0427431f.jpg";